import type { jiraRadioSelectFieldFragment as JiraRadioSelectField } from '@atlassian/jira-business-fields/src/common/field-types/radio-select/fragment/__generated_apollo__/jiraRadioSelectFieldFragment.ts';
import { RADIO_BUTTONS_CF_TYPE } from '@atlassian/jira-platform-field-config';
import { RADIO_SELECT_GQL_TYPE } from '../constants';
import type { TransformedRadioSelectField } from '../types';
import type { RadioSelectTransformMapping } from './types';

export const transformRadioSelectField = (): RadioSelectTransformMapping => ({
	[RADIO_SELECT_GQL_TYPE]: (field: JiraRadioSelectField): TransformedRadioSelectField | null => {
		if (field.__typename !== RADIO_SELECT_GQL_TYPE) {
			return null;
		}

		return {
			type: RADIO_BUTTONS_CF_TYPE,
			fieldId: field.fieldId,
			name: field.name,
			isEditable: !!field.fieldConfig?.isEditable,
			value: field.selectedOption
				? {
						id: field.selectedOption.optionId,
						value: field.selectedOption.value ?? '',
					}
				: null,
		};
	},
});
